import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Add } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { getArmazon, saveArmazon } from "../../services/ArmazonService";
import { deleteFileBucket, getFileByUrl } from "../../services/BucketBackService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../utils/Message";
import ColorDialog from "../dialogs/ColorDialog";
import CodigoExternoDialog from "../dialogs/CodigoExternoDialog";
import OrigenCristalDialog from "../dialogs/OrigenCristalDialog";
import FotoDialog from "../dialogs/FotoDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import { generaCodigo } from "../../utils/utils";

const initialState = {
  id: null,
  codigo: "",
  descripcion: "ARMAZON",
  modelo: "",
  idArAsMarca: null,
  idArAsCategoria: null,
  idArAsMaterial: null,
  idArAsFormato: null,
  idArAsCalibre: null,
  idArAsTipo: null,
  codigoExterno: "",
  ubicacion: "",
  existenciaMinima: 0,
  puntoPedido: 0,
  existenciaMaxima: 0,
  disponibleOs: false,
  observaciones: "",
};

const nameItemsText = "Armazón";
//
// #############################################################################
//
const Armazon = () => {
  const params = useParams();
  const _idArticulo = params.idArticulo;
  const _action = params.action;
  const navigate = useNavigate();
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openCodigoExternoDialog, setOpenCodigoExternoDialog] = useState(false);
  const [openColorDialog, setOpenColorDialog] = useState(false);
  const [openOrigenCristalDialog, setOpenOrigenCristalDialog] = useState(false);
  const [openFotoDialog, setOpenFotoDialog] = useState(false);
  const [codigoExternoList, setCodigoExternoList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [origenCristalList, setOrigenCristalList] = useState([]);
  const [fotoList, setFotoList] = useState([]);
  const [actionCrud, setActionCrud] = useState("");
  const [itemCrud, setItemCrud] = useState(initialState);
  const [arrayFotos, setArrayFotos] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const [titleComponent, setTitleComponent] = useState("");
  const [arAsCategorias, setArAsCategorias] = useState([]);
  const [arAsMateriales, setArAsMateriales] = useState([]);
  const [arAsFormatos, setArAsFormatos] = useState([]);
  const [arAsCalibres, setArAsCalibres] = useState([]);
  const [arAsTipos, setArAsTipos] = useState([]);
  const [arAsMarcas, setArAsMarcas] = useState([]);
  const [valueACArAsMarca, setValueACArAsMarca] = useState(null);
  const [inputValueACArAsMarca, setInputValueACArAsMarca] = useState("");
  const [valueACArAsCategoria, setValueACArAsCategoria] = useState(null);
  const [inputValueACArAsCategoria, setInputValueACArAsCategoria] = useState("");
  const [valueACArAsMaterial, setValueACArAsMaterial] = useState(null);
  const [inputValueACArAsMaterial, setInputValueACArAsMaterial] = useState("");
  const [valueACArAsFormato, setValueACArAsFormato] = useState(null);
  const [inputValueACArAsFormato, setInputValueACArAsFormato] = useState("");
  const [valueACArAsCalibre, setValueACArAsCalibre] = useState(null);
  const [inputValueACArAsCalibre, setInputValueACArAsCalibre] = useState("");
  const [valueACArAsTipo, setValueACArAsTipo] = useState(null);
  const [inputValueACArAsTipo, setInputValueACArAsTipo] = useState("");

  const tableColumnsColorList = [
    {
      field: "descripcion_ar_as_color",
      headerName: "Color",
      headerAlign: "center",
      align: "left",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_color;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {(_action === "new" || _action === "update") && (
            <>
              <Tooltip title="quitar color">
                <span>
                  <IconButton
                    size="small"
                    aria-label="delete"
                    onClick={() =>
                      handleClickColor(params.row, "delete")
                    }
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsOrigenCristalList = [
    {
      field: "descripcion_cr_origen",
      headerName: "Origen de Cristales",
      headerAlign: "center",
      align: "left",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_cr_origen;
        _val = _val ? _val : "";
        return _val;
      },

    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {(_action === "new" || _action === "update") && (
            <>
              <Tooltip title="quitar origen de cristales">
                <span>
                  <IconButton
                    size="small"
                    aria-label="delete"
                    onClick={() =>
                      handleClickOrigenCristal(params.row, "delete")
                    }
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsCodigoExternoList = [
    {
      field: "descripcion_proveedor",
      headerName: "Proveedor",
      headerAlign: "center",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.descripcion_proveedor}</span>
      ),
    },
    {
      field: "codigo_externo",
      headerName: "Código Externo",
      headerAlign: "center",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.codigo_externo}</span>
      ),
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {(_action !== "disable" && (actionCrud === "new" || actionCrud === "update")) && (
            <>
              <Tooltip title="Editar Código Externo">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickCodigoExterno(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Quitar Código Externo">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickCodigoExterno(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsFotoList = [
    {
      field: "preview",
      headerName: "Vista Previa",
      headerAlign: "center",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const archivo = params.row.archivo;
        let id_s3 = params.row.id_s3;
        let urlImg = getFileByUrl(id_s3);
        if (archivo !== undefined) {
          if (archivo.type.startsWith("image/")) {
            return (
              <img
                src={URL.createObjectURL(archivo)}
                alt="preview"
                style={{
                  width: 70,
                  height: 70,
                  objectFit: "cover",
                  borderRadius: "5px",
                  display: "block"
                }}
              />
            );
          } else {
            return <span>No disponible</span>;
          }
        } else {
          return (
            <img
              src={urlImg}
              alt="preview"
              style={{
                width: 70,
                height: 70,
                objectFit: "cover",
                borderRadius: "5px",
                display: "block"
              }}
            />
          );
        }
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {(_action !== "disable" && (actionCrud === "new" || actionCrud === "update")) && (
            <>
              <Tooltip title="Quitar Foto">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickFoto(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableOptionsColorList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_ar_as_color,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsCodigoExternoList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_proveedor,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsOrigenCristalList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_cr_origen,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsFotoList = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_s3,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
        display: 'flex',
        alignItems: "center",
        padding: '8px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
      '& .MuiDataGrid-row': {
        minHeight: '120px !important',
        maxHeight: '120px !important',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      '& .MuiDataGrid-cell[data-field="preview"]': {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        padding: '4px',
        overflow: 'hidden',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    loadArAsCategorias();
    loadArAsMateriales();
    loadArAsFormatos();
    loadArAsCalibres();
    loadArAsTipos();
    loadArAsMarcas();

    if (_action === "new") {
      setTitleComponent("Nuevo " + nameItemsText);
      setItemCrudLocal({
        ...itemCrudLocal,
        codigo: generaCodigo(),
      });
    } else {
      load();
      setActionCrud(_action);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadArAsCategorias = async () => {
    const response = await getCacheData("ar_as_categoria");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsCategorias(_var);
    } else {
      setArAsCategorias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsMateriales = async () => {
    const response = await getCacheData("ar_as_material");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMateriales(_var);
    } else {
      setArAsMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsFormatos = async () => {
    const response = await getCacheData("ar_as_formato")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsFormatos(_var);
    } else {
      setArAsFormatos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsCalibres = async () => {
    const response = await getCacheData("ar_as_calibre")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor),
        });
      });
      setArAsCalibres(_var);
    } else {
      setArAsCalibres([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsTipos = async () => {
    const response = await getCacheData("ar_as_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsTipos(_var);
    } else {
      setArAsTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsMarcas = async () => {
    const response = await getCacheData("ar_as_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMarcas(_var);
    } else {
      setArAsMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  // 
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/articulo/armazon-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickCodigoExterno = (itemCrud, action) => {
    let _itemCrud = {}

    if (action === "delete") {
      const updatedList = codigoExternoList.filter(
        (item) => item.id_proveedor !== itemCrud.id_proveedor
      );
      setCodigoExternoList(updatedList);
      return;
    }

    if (action === "update") {
      _itemCrud = {
        id: itemCrud.id ? itemCrud.id : uuid(),
        id_proveedor: itemCrud.id_proveedor,
        descripcion_proveedor: itemCrud.descripcion_proveedor,
        codigo_externo: itemCrud.codigo_externo,
      }
      setItemCrud(_itemCrud);
      setActionCrud(action);
      setOpenCodigoExternoDialog(true);
    } else {
      setActionCrud(action);
      setItemCrud(itemCrud);
      setOpenCodigoExternoDialog(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleClickOrigenCristal = (parItemCrud, parActionCrud) => {
    let _itemCrud = {}

    if (parActionCrud === "new") {
      setOpenOrigenCristalDialog(true);
    } else {
      // delete origen

      const _updatedList = origenCristalList.filter(
        (item) => item.id !== parItemCrud.id
      );
      setOrigenCristalList(_updatedList);
      return;
    }
  };
  //
  // ##########################################################################
  //
  const handleClickColor = (parItemCrud, parActionCrud) => {
    let _itemCrud = {}

    if (parActionCrud === "new") {
      setOpenColorDialog(true);
    } else {
      // delete color

      const _updatedList = colorList.filter(
        (item) => item.id !== parItemCrud.id
      );
      setColorList(_updatedList);
      return;
    }
  };
  //
  // ##########################################################################
  //
  const handleClickFoto = (itemCrud, action) => {
    if (action === "delete") {
      const updatedList = fotoList.filter(
        (item) => item.id_s3 !== itemCrud.id_s3
      );
      deleteFileBucket(itemCrud.id_s3);
      setFotoList(updatedList);
      return;
    }
    // Validar que no se excedan las 10 fotos
    if (fotoList.length >= 10) {
      setMessage({
        messageText: "Solo se pueden ingresar un máximo de 10 fotos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    setActionCrud(action);
    setOpenFotoDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async () => {

    if (itemCrudLocal.descripcion === "") {
      setMessage({
        messageText: "Debes ingresar alguna Descripción",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (itemCrudLocal.modelo === "") {
      setMessage({
        messageText: "Debes ingresar el modelo",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsMarca) {
      setMessage({
        messageText: "Debes Seleccionar la Marca",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsCategoria) {
      setMessage({
        messageText: "Debes Seleccionar la Categoría",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsMaterial) {
      setMessage({
        messageText: "Debes seleccionar el Material",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsFormato) {
      setMessage({
        messageText: "Debes seleccionar el Formato",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsCalibre) {
      setMessage({
        messageText: "Debes seleccionar el Calibre",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACArAsTipo) {
      setMessage({
        messageText: "Debes seleccionar el Tipo",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const _existenciaMinima = Math.max(0, +itemCrudLocal.existenciaMinima);
    const _puntoPedido = Math.max(0, +itemCrudLocal.puntoPedido);
    const _existenciaMaxima = Math.max(0, +itemCrudLocal.existenciaMaxima);

    if (_existenciaMinima > _puntoPedido || _puntoPedido > _existenciaMaxima) {
      setMessage({
        messageText: "Los valores de Existencia Mínima, Punto de Pedido y Existencia Máxima no son válidos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (origenCristalList.length === 0) {
      setMessage({
        messageText: "Debes ingresar al menos un origen de cristales",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (colorList.length === 0) {
      setMessage({
        messageText: "Debes ingresar al menos un color para el Armazón",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    let object = {};

    if (_action === "update") {
      object.id = itemCrudLocal.id;
    }
    object = {
      ...itemCrudLocal,
      codigo: itemCrudLocal.codigo,
      descripcion: itemCrudLocal.descripcion.toUpperCase(),
      modelo: itemCrudLocal.modelo.toUpperCase(),
      idArAsCategoria: valueACArAsCategoria.id,
      idArAsMaterial: valueACArAsMaterial.id,
      idArAsFormato: valueACArAsFormato.id,
      idArAsCalibre: valueACArAsCalibre.id,
      idArAsTipo: valueACArAsTipo.id,
      idArAsMarca: valueACArAsMarca.id,
      ubicacion: itemCrudLocal.ubicacion.toUpperCase(),
      existenciaMinima: _existenciaMinima,
      puntoPedido: _puntoPedido,
      existenciaMaxima: _existenciaMaxima,
      lsColorList: colorList ? colorList : [],
      lsCodigoExternoList: codigoExternoList ? codigoExternoList : [],
      lsOrigenCristalList: origenCristalList ? origenCristalList : [],
      lsFotoList: fotoList ? fotoList : [],
      observaciones: itemCrudLocal.observaciones.toUpperCase(),
      disponibleOs: itemCrudLocal.disponibleOs
    }

    setIsDoingSomething(true);
    const response = await saveArmazon(_action, object);
    setIsDoingSomething(false);

    if (response.ok) {
      setTimeout(() => {
        navigate("/articulo/armazon-table");
      }, 500);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getArmazon({ id: _idArticulo });
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      if (_action === "update") {
        setTitleComponent("Editando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText + ' ' + _response.codigo);
      }

      let _codigoExternoList = _response.codigo_externo_list.map((item) => {
        return {
          id: item.id,
          id_proveedor: item.id_proveedor,
          descripcion_proveedor: item.descripcion_proveedor + (item.contacto_proveedor ? " - " + item.contacto_proveedor : ""),
          codigo_externo: item.codigo_externo,
        }
      });
      setCodigoExternoList(_codigoExternoList);

      let _colorList = _response.color_list.map((item) => {
        return {
          id: item.id_ar_as_color,
          descripcion_ar_as_color: item.descripcion_ar_as_color,
        }

      });
      setColorList(_colorList);

      let _origenCristalList = _response.cristal_origen_list.map((item) => {
        return {
          id: item.id_cr_origen,
          descripcion_cr_origen: item.descripcion_cr_origen,
        }

      });
      setOrigenCristalList(_origenCristalList);

      let _fotoList = _response.foto_list.map((item) => {
        return {
          id: item.id,
          id_s3: item.id_s3

        }
      }
      );
      setFotoList(_fotoList);

      setItemCrudLocal({
        ...itemCrudLocal,
        id: _response.id,
        codigo: _response.codigo,
        descripcion: _response.descripcion,
        modelo: _response.modelo,
        ubicacion: _response.ubicacion,
        existenciaMinima: _response.existencia_minima,
        puntoPedido: _response.punto_pedido,
        existenciaMaxima: _response.existencia_maxima,
        observaciones: _response.observaciones,
        disponibleOs: _response.disponible_obra_social,
      });
      setValueACArAsMarca({
        id: _response.id_ar_as_marca,
        label: _response.descripcion_ar_as_marca,
      });
      setValueACArAsCategoria({
        id: _response.id_ar_as_categoria,
        label: _response.descripcion_ar_as_categoria,
      });
      setValueACArAsMaterial({
        id: _response.id_ar_as_material,
        label: _response.descripcion_ar_as_material,
      });
      setValueACArAsFormato({
        id: _response.id_ar_as_formato,
        label: _response.descripcion_ar_as_formato,
      });
      setValueACArAsCalibre({
        id: _response.id_ar_as_calibre,
        label: String(_response.valor_ar_as_calibre),
      });
      setValueACArAsTipo({
        id: _response.id_ar_as_tipo,
        label: _response.descripcion_ar_as_tipo,
      });

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleCloseCodigoExternoDialog = () => {
    setOpenCodigoExternoDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseColorDialog = () => {
    setOpenColorDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseOrigenCristalDialog = () => {
    setOpenOrigenCristalDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseFotoDialog = () => {
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################
  //
  const handleOnSaveCodigoExterno = (parItemCrud, parAction) => {
    let _codigoExternoList = [...codigoExternoList];
    if (parAction !== "delete") {
      let _existe = false
      _codigoExternoList.forEach((item) => {
        if (item.id_proveedor === parItemCrud.id_proveedor) {
          if (item.id !== parItemCrud.id) {
            _existe = true;
          }
        }
      });
      if (_existe) {
        setMessage({
          messageText: "Ya ha sido ingresado un Código Externo para el Proveedor seleccionado",
          severity: "error",
        });
        setShowMessage(true);
        return false;
      }
      if (parAction === "new") {
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        return true;
      } else {
        _codigoExternoList.splice(
          _codigoExternoList.findIndex((item) =>
            item.id_proveedor === parItemCrud.id_proveedor), 1)
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        setOpenCodigoExternoDialog(false);
        return true;
      }
    } else {
      _codigoExternoList.splice(_codigoExternoList.findIndex((item) =>
        item.id_proveedor === parItemCrud.id_proveedor), 1)
      setCodigoExternoList(_codigoExternoList);
    }
  }
  //
  // ################################################################################
  //
  const handleOnSaveColor = (parItemCrud) => {
    let _colorList = [...colorList];

    let _existe = false

    _colorList.forEach((item) => {
      if (item.id === parItemCrud.id) {
        _existe = true;
      }
    });

    if (_existe) {
      setMessage({
        messageText: "Ya ha sido ingresado este Color",
        severity: "error",
      });
      setShowMessage(true);
      return false;
    }

    _colorList.push(parItemCrud);
    setColorList(_colorList);
    return true;
  }
  //
  // ################################################################################
  //
  const handleOnSaveOrigenCristal = (parItemCrud, parAction) => {
    let _origenCristalList = [...origenCristalList];

    let _existe = false

    _origenCristalList.forEach((item) => {
      if (item.id === parItemCrud.id) {
        _existe = true;
      }
    });

    if (_existe) {
      setMessage({
        messageText: "Ya ha sido ingresado este Origen de Cristales",
        severity: "error",
      });
      setShowMessage(true);
      return false;
    }

    _origenCristalList.push(parItemCrud)
    setOrigenCristalList(_origenCristalList);
    return true;
  }
  //
  // ################################################################################
  //
  const handleOnSaveFoto = (items) => {
    // Validar que no se excedan las 10 fotos
    if (fotoList.length + items.length > 10) {
      setMessage({
        messageText: `Solo se pueden ingresar un máximo de 10 fotos. Actualmente tienes ${fotoList.length} foto(s) y estás intentando agregar ${items.length} foto(s).`,
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    // busco dentro de fotoList si existe el id_s3
    let _varList = [...fotoList];
    let _existe = false;
    _varList.forEach((itemList) => {
      items.forEach((item) => {
        if (itemList.nombre === item.nombre) {
          _existe = true;
        }
      }
      );
    });
    if (_existe) {
      setMessage({
        messageText: "Al menos una de las fotos ya se encuentra en la lista",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    setFotoList(
      fotoList.concat(items)
    );
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {titleComponent}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={itemCrudLocal.codigo}
                  onChange={handleChange}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion ? itemCrudLocal.descripcion : ""}
                  onChange={handleChange}
                  // disabled={actionCrud === "disable" || actionCrud === "enable"}
                  disabled={true}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-marca"
                  size="small"
                  sx={{ width: "100%", pb: 1 }}
                  value={
                    valueACArAsMarca && valueACArAsMarca.id
                      ? valueACArAsMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsMarca(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsMarca(newInputValue);
                  }}
                  options={arAsMarcas}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Marca"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsMarcas();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="modelo"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="modelo"
                  value={itemCrudLocal.modelo ? itemCrudLocal.modelo : ""}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-categoria"
                  size="small"
                  sx={{ width: "100%", pb: 1 }}
                  value={
                    valueACArAsCategoria && valueACArAsCategoria.id
                      ? valueACArAsCategoria
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsCategoria(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsCategoria: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsCategoria}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsCategoria(newInputValue);
                  }}
                  options={arAsCategorias}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Categoría"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsCategorias();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-material"
                  size="small"
                  sx={{ width: "100%", mb: 1 }}
                  value={
                    valueACArAsMaterial && valueACArAsMaterial.id
                      ? valueACArAsMaterial
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsMaterial(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsMaterial: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsMaterial}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsMaterial(newInputValue);
                  }}
                  options={arAsMateriales}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Material"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsMateriales();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-formato"
                  size="small"
                  value={
                    valueACArAsFormato && valueACArAsFormato.id
                      ? valueACArAsFormato
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsFormato(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsFormato: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsFormato}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsFormato(newInputValue);
                  }}
                  options={arAsFormatos}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Formato"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsFormatos();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-calibre"
                  sx={{ width: "100%", pb: 1 }}
                  size="small"
                  value={
                    valueACArAsCalibre && valueACArAsCalibre.id
                      ? valueACArAsCalibre
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsCalibre(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsCalibre: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsCalibre}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsCalibre(newInputValue);
                  }}
                  options={arAsCalibres}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Calibre"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsCalibres();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  id="id-ar-as-tipo"
                  size="small"
                  sx={{ width: "100%", mb: 1 }}
                  value={
                    valueACArAsTipo && valueACArAsTipo.id
                      ? valueACArAsTipo
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsTipo(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idArAsTipo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsTipo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsTipo(newInputValue);
                  }}
                  options={arAsTipos}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadArAsTipos();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="ubicacion"
                  label="Ubicación"
                  variant="outlined"
                  size="small"
                  name="ubicacion"
                  value={itemCrudLocal.ubicacion}
                  onChange={handleChange}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={itemCrudLocal.disponibleOs ?? false}
                      onChange={handleChange}
                      sx={{ ml: 4 }}
                      name="disponibleOs"
                      color="primary"
                      disabled={
                        actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view" === true
                      }
                    />
                  }
                  label="Disponible para Obra Social"
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMinima"
                  label="Existencia Mínima"
                  variant="outlined"
                  size="small"
                  name="existenciaMinima"
                  value={itemCrudLocal.existenciaMinima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="puntoPedido"
                  label="Punto de Pedido"
                  variant="outlined"
                  size="small"
                  name="puntoPedido"
                  value={itemCrudLocal.puntoPedido}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMaxima"
                  label="Existencia Máxima"
                  variant="outlined"
                  size="small"
                  name="existenciaMaxima"
                  value={itemCrudLocal.existenciaMaxima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="agregar color">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickColor({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        startIcon={<Add />}
                      >
                        Color
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={colorList}
                    columns={tableColumnsColorList}
                    {...tableOptionsColorList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="agregar código externo">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickCodigoExterno({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        startIcon={<Add />}
                      >
                        Código externo
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={codigoExternoList}
                    columns={tableColumnsCodigoExternoList}
                    {...tableOptionsCodigoExternoList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="agregar origen de cristales">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickOrigenCristal({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        startIcon={<Add />}
                      >
                        Origen de Cristales
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={origenCristalList}
                    columns={tableColumnsOrigenCristalList}
                    {...tableOptionsOrigenCristalList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title={fotoList.length >= 10 ? "Máximo de 10 fotos alcanzado" : "Ingresar Foto"}>
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickFoto({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        disabled={fotoList.length >= 10}
                        startIcon={<Add />}
                      >
                        Foto ({fotoList.length}/10)
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <Box sx={{
                    maxHeight: "380px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "center",
                    position: "relative"
                  }}>
                    <DataGrid
                      rows={fotoList}
                      columns={tableColumnsFotoList}
                      {...tableOptionsFotoList}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ m: 1, mx: 5 }}>
              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  inputProps={{
                    autoComplete: "off"
                  }}
                  id="observaciones"
                  label="Observaciones"
                  variant="outlined"
                  name="observaciones"
                  value={itemCrudLocal.observaciones}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: '80px',
                      minWidth: '400px',
                    }
                  }}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                />
              </Grid>
            </Box>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", py: 1, pr: 5 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={_action === "disable" ? "error" : "primary"}
                  startIcon={
                    _action === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : _action === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {_action === "disable"
                    ? "Deshabilitar"
                    : _action === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelar}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Box>
        </Paper>
      </Paper >

      {openColorDialog && (
        <ColorDialog
          onSave={handleOnSaveColor}
          onClose={handleCloseColorDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openCodigoExternoDialog && (
        <CodigoExternoDialog
          onSave={handleOnSaveCodigoExterno}
          onClose={handleCloseCodigoExternoDialog}
          actionCrud={actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openOrigenCristalDialog && (
        <OrigenCristalDialog
          onSave={handleOnSaveOrigenCristal}
          onClose={handleCloseOrigenCristalDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openFotoDialog && (
        <FotoDialog
          onSave={handleOnSaveFoto}
          onClose={handleCloseFotoDialog}
          actionCrud={actionCrud}
          arrayFotos={arrayFotos}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Armazon;
